// @ts-nocheck
import { API_URL, authFetch } from './api';

async function request(path, options) {
  const response = await authFetch(`${API_URL}/api/data-entry-drafts${path}`, options);
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(typeof body.detail === 'string' ? body.detail : 'Could not complete the draft request. Please retry.');
  }
  return response.json();
}

export function fetchDataEntryDrafts(schoolId, studentId) {
  const query = new URLSearchParams({ school_id: schoolId });
  if (studentId != null) query.set('student_id', studentId);
  return request(`/?${query}`);
}

export function saveDataEntryDraft(id, schoolId, form) {
  return request(id == null ? '/' : `/${id}`, {
    method: id == null ? 'POST' : 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ school_id: schoolId, form }),
  });
}

export function deleteDataEntryDraft(id) {
  return request(`/${id}`, { method: 'DELETE' });
}

export function publishDataEntryDraft(id, points) {
  return request(`/${id}/publish`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ points }),
  });
}
